export default __webpack_public_path__ + "static/media/welcome-review.2b2ece00.svg";